import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { TradingOfferOperationStatus } from 'types/TradingOfferOperation';
import { OperationTimelineStep } from '../types/TradingOfferOperationDetailContextType';

const formatDateTime = (date: Date | string | undefined) => {
  if (!date) return '-';
  return format(new Date(date), "dd MMM yyyy · HH:mm'h'", { locale: es });
};

type TradingOfferOperationDetailTimelineProps = {
  steps: OperationTimelineStep[];
};

const TradingOfferOperationDetailTimeline: FC<
  TradingOfferOperationDetailTimelineProps
> = ({ steps }) => {
  const { t } = useTranslate();

  const isInReviewBadgeVisible = (step: OperationTimelineStep) =>
    step.isCurrent && step.key !== TradingOfferOperationStatus.COMPLETED;

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-4">
          <em className="icon ni ni-list-check text-primary mr-2" />
          {t('OperationProgress')}
        </h6>

        <div className="timeline-op">
          {steps.map((step) => {
            let stepClass = 'pending';
            if (step.isCompleted) stepClass = 'done';
            else if (step.isCurrent) stepClass = 'current';

            return (
              <div key={step.key} className={`tl-item ${stepClass}`}>
                <div className="tl-icon">
                  <em
                    className={`icon ni ${
                      step.isCompleted ? 'ni-check' : step.icon
                    }`}
                  />
                </div>

                <div className="tl-content">
                  <div className="tl-title">{t(step.label)}</div>
                  <div className="tl-subtitle">
                    {step.date
                      ? `${formatDateTime(step.date)} — `
                      : `${t('Pending')} — `}
                    {t(step.description)}
                  </div>

                  {isInReviewBadgeVisible(step) && (
                    <div className="mt-2">
                      <span className="badge badge-dim badge-warning">
                        {t('InReview')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TradingOfferOperationDetailTimeline;
